import { useTranslation } from '../i18n';
import CardNB from './ui-nb/CardNB';
import IconNB from './ui-nb/IconNB';

const features = [
  {
    key: 'everyRepair',
    icon: 'orders',
  },
  {
    key: 'branchOrganized',
    icon: 'branches',
  },
  {
    key: 'instantUpdates',
    icon: 'equipment',
  },
];

export default function FeatureCardsNB() {
  const { t } = useTranslation();

  return (
    <section id="features" className="bg-nb-white py-12 md:py-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        {/* Section header */}
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-nb font-bold text-xl md:text-2xl lg:text-3xl text-nb-black mb-2 md:mb-3">
            {t('features.title')}
          </h2>
          <p className="text-nb-text-muted text-sm md:text-base">
            {t('features.subtitle')}
          </p>
        </div>

        {/* Cards — bento grid, 3-col desktop, 2-col tablet, 1-col mobile */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <CardNB key={feature.key} variant="interactive" className="text-center">
              <div className="w-8 h-8 mx-auto mb-4 flex items-center justify-center">
                <IconNB name={feature.icon} size={32} className="text-nb-black" />
              </div>
              <h3 className="font-nb font-bold text-lg text-nb-black mb-2">
                {t(`features.${feature.key}.title`)}
              </h3>
              <p className="text-nb-text-secondary text-base leading-relaxed">
                {t(`features.${feature.key}.description`)}
              </p>
            </CardNB>
          ))}
        </div>
      </div>
    </section>
  );
}
